// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table .warning-row {\n  background: oldlace;\n}\n.el-table .offline {\n  background: #fcbdbd;\n}\n.el-table .success-row {\n  background: #f0f9eb;\n}\n.responsive-table-shell {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.nowrap-table {\n  width: 100%;\n}\n.mvm-list-table {\n  min-width: 1760px;\n}\n.nowrap-table .cell {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
